module.exports = __webpack_public_path__ + "static/media/05-img-01@3x.e9b4f13a.webp";